module.exports = __webpack_public_path__ + "img/del-input.fb48d2dc.svg";